import React from "react";
import ContentLoader from "react-content-loader";

import "./style.scss";

const Text = ({ ...props }) => {
  return (
    <ContentLoader
      speed={2}
      width="100%"
      viewBox="0 0 340 28"
      backgroundColor="#d6d6d6"
      foregroundColor="#ededed"
      className="placeholder"
      {...props}
    >
      <rect x="0" y="0" rx="3" ry="3" width="200" height="28" />
    </ContentLoader>
  );
};

export default Text;
